import axios from "axios";
import { APIURL } from "../../../../APIHandler/APIURL"
import { Headers } from "../../../../APIHandler/HeaderAPI";
import { reloadHandler } from "../../../../utlis/utlis";
import { Get_ID_speakers_failure, Get_ID_speakers_request, Get_ID_speakers_success } from "../../../Reducer/Admin/Speakers/GetIdSpeakerSlice";

export const GetIdSpeakerAPI = (payload) => async (dispatch, getState) => {
    // const eventItemId=localStorage.getItem("eventItemId")
    const auth_token = localStorage.getItem("auth_token")
    dispatch(Get_ID_speakers_request())
    try {
        const { data } = await axios.get(`${APIURL.getidspeakers}/${payload}`, {
            headers: {
                "host-url": Headers?.["host-url"],
                "language": Headers?.language,
               "event-slug":Headers?.["event-slug"],
                "Content-type": "application/json",
                Authorization: `Bearer ${auth_token}`
            },
        })
      
        dispatch(Get_ID_speakers_success(data))
    } catch (error) {
        reloadHandler(error?.response?.status)
        dispatch(Get_ID_speakers_failure(error?.response?.data))
    }
}

